interface PriceWithMortgageInitial {
  total?: number | null;
  mortgageInitial?: number | null;
}

export const getBasePrice = (
  price?: PriceWithMortgageInitial | null
): number | null | undefined => price?.mortgageInitial ?? price?.total;
